import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#495964" }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11 1.00003L1 11" stroke={fill} strokeWidth="2" />
      <path d="M11 11L1 0.999998" stroke={fill} strokeWidth="2" />
    </svg>
  );
};

export default memo(Icon);
